import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import loadConfig from "../../../../Services/Api/ApiServices";

import Swal from "sweetalert2";
import SharedDiv from "../../../../Components/SharedDiv/SharedDiv";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";

import { GetAllFields } from "../../../../Redux/Reducers/Submitter/ResearchProposalInformation/FieldDropDown";
import {
  GetResearchProposalInformation,
  SetResearchProposalInformation,
  UpdateResearchProposalInformation,
  ValidateResearchProposalInformation,
} from "../../../../Redux/Reducers/Submitter/ResearchProposalInformation";
import LoaderAHSF from "../../../../Components/LoaderAHSF";

const ResearchProposalInformationModule = (porps) => {
  //   const AppGuid = useParams();
  const dispatch = useDispatch();
  const UpdateResult = useSelector(
    (state) =>
      state.ResearchProposalInformation.UpdateResearchProposalInformation
  );
  const state = useSelector((state) => {
    return {
      DropDownFields: state.DropDownFields.DropDownFields,
      ResearchProposalInformation:
        state.ResearchProposalInformation.ResearchProposalInformation,
      loadingGetResearchProposalInformation:
        state.ResearchProposalInformation.loadingGetResearchProposalInformation,
      ResearchProposalInformationValidate:
        state.ResearchProposalInformation.ResearchProposalInformationValidate,
      UpdateResearchProposalInformation:
        state.ResearchProposalInformation.UpdateResearchProposalInformation,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const ResultDropDown = useSelector(
    (state) => state.DropDownFields.DropDownFields
  );
  const [
    ResearchProposalInformationState,
    setResearchProposalInformationState,
  ] = useState({
    ...state.ResearchProposalInformation,
  });
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };

  useEffect(() => {
    dispatch(
      GetAllFields(
        localStorage.getItem("ApplicationInformationId") ||
          porps.applicationInformationId
      )
    );
  }, []);

  useEffect(() => {
    dispatch(
      GetResearchProposalInformation(
        // state.ApplicationInformation?.applicationInformationId
        localStorage.getItem("ApplicationInformationId") ||
          porps.applicationInformationId
        //  ||
        //   decryptToken(AppGuid.AppGuid)
      )
    );
  }, [
    localStorage.getItem("ApplicationInformationId"),
    porps.applicationInformationId,
    ,
  ]);

  useEffect(() => {
    if (!state.loadingGetResearchProposalInformation) {
      console.log(state.ResearchProposalInformation, "shomaaaaaan");

      setResearchProposalInformationState({
        ...state.ResearchProposalInformation,
      });
    }
  }, [state.loadingGetResearchProposalInformation]);
  useEffect(() => {
    dispatch(
      SetResearchProposalInformation({ ...ResearchProposalInformationState })
    );
  }, [ResearchProposalInformationState]);

  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  console.log(state.ResearchProposalInformation?.fieldId,"filed");
  

  return (
    <>
      {state.ResearchProposalInformation?.applicationInformationId && ResultDropDown ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="معلومات المقترح البحثي "
            child={[
              <div className="form-grid">
                <AllDropDownsAHSF
                  fieldsName="Field"
                  show={true}
                  disabled={shouldDisableFields}
                  arrayOoptionList={state.DropDownFields}
                  KeyText={"fieldName"}
                  KeyValue={"fieldId"}
                  dropdownType={"normal"}
                  defaultValue={state.ResearchProposalInformation?.fieldId}
                  onChange={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      fieldId: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "Field"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <InputAHSF
                  fieldsName="SpecializedResearchProjectScope"
                  show={true}
                  disabled={shouldDisableFields}
                  value={
                    state.ResearchProposalInformation
                      ?.specializedResearchProjectScope
                  }
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   specializedResearchProjectScope: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      specializedResearchProjectScope: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "SpecializedResearchProjectScope"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <InputAHSF
                  fieldsName="KeywordsAboutTheResearchProject"
                  show={true}
                  disabled={shouldDisableFields}
                  value={
                    state.ResearchProposalInformation
                      ?.keywordsAboutTheResearchProject
                  }
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   keywordsAboutTheResearchProject: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      keywordsAboutTheResearchProject: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "KeywordsAboutTheResearchProject"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <InputAHSF
                  fieldsName="ResearchProjectTitleInArabic"
                  type={"arabic"}
                  show={true}
                  disabled={shouldDisableFields}
                  value={
                    state.ResearchProposalInformation
                      ?.researchProjectTitleInArabic
                  }
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   researchProjectTitleInArabic: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      researchProjectTitleInArabic: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "ResearchProjectTitleInArabic"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <InputAHSF
                  fieldsName="ResearchProjectTitleInEnglish"
                  type={"english"}
                  show={true}
                  disabled={shouldDisableFields}
                  value={
                    state.ResearchProposalInformation
                      ?.researchProjectTitleInEnglish
                  }
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   researchProjectTitleInEnglish: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      researchProjectTitleInEnglish: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "ResearchProjectTitleInEnglish"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />

                <TextAreaAHSF
                  fieldsName="ResearchProjectSummaryInArabic"
                  type={"arabic"}
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ResearchProposalInformation
                      ?.researchProjectSummaryInArabic
                  }
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   researchProjectSummaryInArabic: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      researchProjectSummaryInArabic: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "ResearchProjectSummaryInArabic"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="ResearchProjectSummaryInEnglish"
                  type={"english"}
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ResearchProposalInformation
                      ?.researchProjectSummaryInEnglish
                  }
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   researchProjectSummaryInEnglish: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      researchProjectSummaryInEnglish: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "ResearchProjectSummaryInEnglish"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="LiteratureReview"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ResearchProposalInformation?.literatureReview
                  }
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   literatureReview: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      literatureReview: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "LiteratureReview"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="Methodology"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={state.ResearchProposalInformation?.methodology}
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   methodology: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      methodology: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "Methodology"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="ClarifyThePracticalAspectAndTheExpectedImpact"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.ResearchProposalInformation
                      ?.clarifyThePracticalAspectAndTheExpectedImpact
                  }
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   clarifyThePracticalAspectAndTheExpectedImpact:
                    //     e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      clarifyThePracticalAspectAndTheExpectedImpact:
                        e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "ClarifyThePracticalAspectAndTheExpectedImpact"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="TargetGroup"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={state.ResearchProposalInformation?.targetGroup}
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   targetGroup: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      targetGroup: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "TargetGroup"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="Bibliography"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={state.ResearchProposalInformation?.bibliography}
                  onChange={(e) => {
                    // setResearchProposalInformationState({
                    //   ...ResearchProposalInformationState,
                    //   bibliography: e.target.value,
                    // });
                  }}
                  onBlur={(e) => {
                    setResearchProposalInformationState({
                      ...ResearchProposalInformationState,
                      bibliography: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.ResearchProposalInformationValidate
                      ? state.ResearchProposalInformationValidate.includes(
                          "Bibliography"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>,
            ]}
          />
          {/* {!shouldDisableFields ? ( */}
          {/* <div className="containerButtonMAin">
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                SaveDataPage(false);
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "تم حفظ المعلومات بنجاح",
                  showConfirmButton: false,
                  timer: 1500,
                  // width: "500px",
                });
              }}
              disabled={false}
              title={"حفظ"}
              text={"حفظ"}
              show={true}
            />
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                SaveDataPage(true);
              }}
              disabled={false}
              title={"التالي"}
              text={"التالي"}
              show={true}
            />
          </div> */}
          {/* ) : (
            ""
          )} */}
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingGetResearchProposalInformation} />
      {/* <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.ResearchProposalInformationValidate}
      /> */}
    </>
  );
};

export default ResearchProposalInformationModule;
